import React from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { Formik, Form, Field } from "formik";
import { useIntl, FormattedMessage } from "react-intl";
import BottomToTop from "../../../../../../../components/transitions/bottom-to-top";
import { changeCommunicationEmail } from "../../../../../../../../api";
import { Iconfont } from "../../../../../../../components/icon/iconfont";
import { BigButton } from "../../../../../../../components/button";
import { action_fetch_customer } from "../../../../../../../../store/actions/pages/customer";
import { useDispatch } from "react-redux";


const ChangeEmailFrom = props =>{
    const { customer, transaction, onClose } = props;
    const Intl = useIntl();
    const dispatch = useDispatch();

    const submitHandle = async (values, formikBag) =>{
        let response = await changeCommunicationEmail({ transactionId: transaction?.transactionId, email: values.email });
        if(response?.code == 200){
            await dispatch(action_fetch_customer());
            onClose();
        }
        formikBag.setSubmitting(false);
    }

    return <div className={cls.ChangeEmailFromPadding}>
        <Formik 
            onSubmit={submitHandle}
            initialValues={{
                email: customer?.communicationEmail,
            }}
            validate={(values) =>{
                const errors = {};
                //email
                const emailReg = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
                if (!values.email) {
                    errors.email = Intl.formatMessage({ id: 'required', defaultMessage: 'Required' })
                } else if (!emailReg.test(values.email)) {
                    errors.email = Intl.formatMessage({ id: 'invalid_email_address', defaultMessage: '{email} is not a valid email' }, {email: values.email})
                }
                return errors;
            }} 
            // enableReinitialize={true}
        >
            {({ isSubmitting }) =>(
                <Form className={cls.ChangeEmailFrom}>
                    <Field name="email">
                        {({ field, form, meta }) => (
                            <div>
                                <input className={`${cls.EmailInput} ${meta.touched && meta.error ? cls.InputError : ""}`} type="email" {...field} />
                                {meta.touched && meta.error && <div className={cls.FontError}>{meta.error}</div>}
                            </div>
                        )}
                    </Field>

                    <BigButton loading={isSubmitting} type="submit" className={cls.SubmitButton}><FormattedMessage id="submit" defaultMessage="Submit" /></BigButton>
                </Form>
            )}
        </Formik>
    </div>
}

export default props =>{
    useStyles(cls);
    const { show, onClose } = props;

    return <BottomToTop in={show} className={cls.ChangeEmailContainer}>
        <div>
            <div className={cls.Hd}>
                <span><FormattedMessage id="change_email" defaultMessage="Change Email" /></span>

                <Iconfont className={cls.CloseIcon} onClick={onClose}>&#xe6af;</Iconfont>
            </div>

            <ChangeEmailFrom {...props} />
        </div>
    </BottomToTop>
}